import Vue from 'vue/dist/vue'
import { Image } from 'element-ui'
export default {
  components: {
    ElImage: Image
  },
  methods: {
    renderRawDescription(raw) {
      if (!raw) {
        return
      }
      const reg = /(<img[^>\\/>]*?src=['"]([^'"]+)['"].*?(?:>|\/>))/g
      const previewList = []
      let i = -1
      const template = this.$xss(raw).replace(reg, (_, $1, $2) => {
        previewList.push([$2])
        i++
        return `<el-image
            src="${$2}"
            :preview-src-list="previewList[${i}]">
            ${$1}
            </el-image>`
      })
      const RawComponent = Vue.extend({
        components: {
          ElImage: Image
        },
        data() {
          return {
            previewList
          }
        },
        methods: {
          onClickHandler(e) {
            // 点击遮罩关闭预览
            if (e.target.className.includes('el-image-viewer__mask')) {
              e.target.nextSibling.click()
            }
          }
        },
        template: `<div ref="img" @click="onClickHandler">${template}</div>`
      })
      this.$nextTick(() => {
        document.querySelectorAll('.question-render-container').forEach(ele => {
          while (ele.hasChildNodes()) {
            ele.removeChild(ele.firstChild)
          }
          ele.appendChild(new RawComponent().$mount().$el)
        })
      })
    }
  }
}
